import { IGNIS_RED, TERRA_GREEN, WHITE } from "@120wateraudit/waterworks";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";

interface Props {
  onClose: () => void;
  onConfirm: () => Promise<unknown>;
  isCurrentlyActive: boolean;
}

const SubmissionPeriodStatusActiveSwitchModal = ({
  onClose,
  onConfirm,
  isCurrentlyActive,
}: Props): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const confirm: () => Promise<void> = async () => {
    setLoading(true);
    if (await onConfirm()) {
      onClose();
    }
    setLoading(false);
  };

  return (
    <>
      <ModalContentContainer>
        <ModalHeader>
          Are you sure you want to{" "}
          <OpenCloseSpan isActive={!isCurrentlyActive}>
            {!isCurrentlyActive ? "open" : "close"}
          </OpenCloseSpan>{" "}
          this submission period?
        </ModalHeader>
        <ContentHeader>
          {!isCurrentlyActive && (
            <span>
              Opening a submission period will allow new submissions to be
              created until it is{" "}
              <OpenCloseSpan isActive={isCurrentlyActive}>closed</OpenCloseSpan>{" "}
              again.
            </span>
          )}
          {isCurrentlyActive && (
            <span>
              Closing a submission period will prevent any new submissions from
              being created until it is{" "}
              <OpenCloseSpan isActive={isCurrentlyActive}>open</OpenCloseSpan>{" "}
              again.
            </span>
          )}
        </ContentHeader>
        <DeleteButtonWrapper>
          <SubmissionButton
            disabled={loading}
            onClick={confirm}
            isActive={!isCurrentlyActive}
          >
            {isCurrentlyActive
              ? "Close Submission Period"
              : "Open Submission Period"}
          </SubmissionButton>
        </DeleteButtonWrapper>
        <Button disabled={loading} onClick={onClose}>
          Cancel
        </Button>
      </ModalContentContainer>
    </>
  );
};

const ModalContentContainer = styled.div`
  display: flex;
  margin: 0;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 0 5rem 3rem;
`;

const ModalHeader = styled.h3`
  display: flex;
  padding: 16px;
  font-weight: 600;
  text-align: left;
  padding-bottom: 0;
  margin-bottom: 0px;
  span {
    padding: 0 5px;
  }
`;

const ContentHeader = styled.h4`
display: flex
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
`;

const DeleteButtonWrapper = styled.div`
  margin-bottom: 1rem;
  margin-top: 2rem;
`;

const SubmissionButton = styled(Button)<{ isActive: boolean }>`
  &&& {
    background-color: ${(props) => (props.isActive ? TERRA_GREEN : IGNIS_RED)};
    color: ${WHITE};
  }
`;

const OpenCloseSpan = styled.span<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? TERRA_GREEN : IGNIS_RED)};
`;

export default SubmissionPeriodStatusActiveSwitchModal;
